<template>
  <div class="bg-gradient-to-b from-gray-900 via-teal-700 to-teal-600 absolute top-0 bottom-0 right-0 left-0 h-screen w-screen overflow-x-auto">
		<main v-if="!isLoggedIn" class="flex items-center justify-center">
			<LoginForm @login="onLogin"/>
		</main>
		<main v-else>
			<div class="py-6 bg-black border-b border-gray-500 shadow-inner text-white">
				<HermesLogo class="mx-auto"/>
			</div>
    	<RouterView/>
		</main>
  </div>
</template>

<script lang="ts">
import useNetlifyLogin from '#/useNetlifyLogin'

import { defineComponent, ref, onMounted } from 'vue'

import Flex       from '@/components/layout/Flex.vue'
import HermesLogo from '@/components/gui/HermesLogo.vue'
import LoginForm  from '@/components/gui/LoginForm.vue'

export default defineComponent({
	name: 'Hermes',

	components: {
		Flex,
		HermesLogo,
		LoginForm
	},

	setup () {
		const { isAuthorized } = useNetlifyLogin()
		const isLoggedIn = ref<boolean>(false)

		function onLogin () {
			isLoggedIn.value = isAuthorized()
		}

		onMounted(() => onLogin())

		return {
			isLoggedIn,
			onLogin
		}
	}
})
</script>